import React, {useState} from "react";
import I18n from "i18n-js";
import Modal from "react-bootstrap/Modal";
import {addHtmlElementEventListener, setHtmlElementAttribute} from "../../utils/utils";


const PrepaidCardInfoButton = ({ texts, type }) => {

  const [ showPopupInfo, setShowPopupInfo ] = useState(false);

  const changeIcon = (path) => {
    setHtmlElementAttribute(document, 'questionTooltipIcon', "src", path)
  }


  return <React.Fragment>
    {
      type !== 'tooltip' ?
        <button
          className="btn bg-aig-gradient br-50px border-none color-white mt-0 mb-1 mx-2 py-2 px-3 font-weight-bold"
          onClick={() => setShowPopupInfo(true)}
        >
          {I18n.t('js.indexPrepaidCards.infoModalMiddleman.openModalBtn').toUpperCase()}
        </button>
      :
        <sup className="mr-1 cursor-pointer" id="questionTooltipContainer"
           onClick={() => setShowPopupInfo(true)}
        >
          <img src={window.location.origin + '/images/icons/question_light.svg'}
               id="questionTooltipIcon" alt="" width="16" height="16"
               onMouseOver={() => changeIcon("/images/icons/question.svg")}
               onMouseOut={() => changeIcon("/images/icons/question_light.svg")}
          />
        </sup>
    }

    <Modal show={showPopupInfo} onHide={() => setShowPopupInfo(false)} animation={false} size="lg" centered>
      <Modal.Header>
        <Modal.Title>{I18n.t('js.indexPrepaidCards.infoModalMiddleman.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-100 mx-2 px-0 d-block my-4">
          {
            texts.map((text, i) => {
              return <React.Fragment key={`prepaid_card_info_image_${i}`}>
                <p>{text}</p>
                {
                  i === 1 &&
                    <div className="row my-4">
                      <div className="col-12 col-md-6 d-block justify-content-center align-items-center text-center px-0 py-3">
                        <img src={window.location.origin + `/images/gift_card_50_example.jpeg`} alt="" className="gift-card-example-image" />
                      </div>

                      <div className="col-12 col-md-6 d-block justify-content-center align-items-center text-center px-0 py-3">
                        <img src={window.location.origin + `/images/gift_card_100_example.jpeg`} alt="" className="gift-card-example-image" />
                      </div>
                    </div>
                }
              </React.Fragment>
            })
          }
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px text-weight-500"
          onClick={() => setShowPopupInfo(false)}
        >
          {I18n.t('js.common.ok').toUpperCase()}
        </button>

      </Modal.Footer>
    </Modal>
  </React.Fragment>
};

export default PrepaidCardInfoButton;